<template>
  <div class="project-manager-project">
    <div class="project-manager-project-row">
      <div class="project-name">
        <router-link :to="`/projects/${project._id}`">
          {{ project.name }}
        </router-link>
      </div>
      <div class="project-author">
        Submitted by {{ project.author.first_name }}
        {{ project.author.last_name }}
      </div>
      <div class="project-updated">updated {{ when }}</div>
    </div>
    <div class="project-mixes">
      <project-manager-mix
        v-for="mix in project.mixes"
        :key="mix._id"
        :mix="mix"
        :project="project"
      />
    </div>
  </div>
</template>

<script lang="ts">
import { timeDelta } from "@/misc";
import { Project } from "@/models";
import { Options, Vue } from "vue-class-component";
import ProjectManagerMix from "./ProjectManagerMix.vue";
@Options({
  components: {
    ProjectManagerMix,
  },
  props: {
    project: {
      type: Object,
      required: true,
    },
  },
})
export default class ProjectManagerProject extends Vue {
  project!: Project;

  get when() {
    const updated = new Date(this.project.updated_at);
    return timeDelta(updated);
  }
}
</script>

<style lang="scss">
.project-manager-project {
  width: 100%;
  max-width: 800px;
  padding-left: 12px;
}
.project-manager-project-row {
  margin-top: 2px;
  margin-bottom: 2px;
  display: flex;
  width: 100%;

  .project-name {
    flex-grow: 1;
    font-weight: bold;
    a {
      color: black;
      text-decoration: none;
      &:hover {
        text-decoration: underline;
      }
    }
  }

  .project-author {
    width: 220px;
  }

  .project-updated {
    width: 220px;
  }
}
</style>
